module.exports = __webpack_public_path__ + "assets/img/sep.6e4fc699.png";